<div class="section__search">
  <div class="section__search__options">
    <div class="section__search__options__radios">
      <div (click)="changeFlightType(0)" class="section__search__options__radios__radio">
        <img
          [src]="flightType === 0 ? 'assets/svg/radio-check.svg' : './assets/svg/radio-circle.svg'"
          alt="o"
        />
        <span>Ida y vuelta</span>
      </div>
      <div (click)="changeFlightType(1)" class="section__search__options__radios__radio">
        <img
          [src]="flightType === 1 ? 'assets/svg/radio-check.svg' : './assets/svg/radio-circle.svg'"
          alt="o"
        />
        <span>Solo ida</span>
      </div>
      <div (click)="changeFlightType(2)" class="section__search__options__radios__radio">
        <img
          [src]="flightType === 2 ? 'assets/svg/radio-check.svg' : './assets/svg/radio-circle.svg'"
          alt="o"
        />
        <span>Multidestino</span>
      </div>
    </div>
    <div class="section__search__options__dropdowns">
      <app-input-passengers #childPassengers></app-input-passengers>
      <!--<app-input-class #childClass [isSearchFlight]="true"></app-input-class>-->
    </div>
  </div>
  <div *ngIf="flightType !== 2" class="section__search__inputs">
    <app-flight-locations-inputs #childInputs></app-flight-locations-inputs>
    <app-input-range
      #childDates
      (inputDates)="onDateRangeChanged($event)"
      [typeFlight]="flightType"
      [startDate]="rangeStartDate"
    ></app-input-range>
    <div class="d-grid d-lg-inline-block">
      <app-button
        (buttonClick)="handleSearch()"
        [isFullWidth]="true"
        buttonClass="px-4"
        buttonId="btn-search-flights"
        title="Buscar"
      >
        <i aria-label="Buscar" class="custom-icon icon-search"></i>
        <span class="d-lg-none ms-2">Buscar</span>
      </app-button>
    </div>
  </div>
  <app-multivuelo
    *ngIf="flightType === 2"
    (searchDataMulti)="searchMultiCity($event)"
  ></app-multivuelo>
</div>
